import {
  requestNotificationPermission,
  listenForMessages,
} from "./utils/firebaseNotification";
import ChakraUiProvider from "./providers/ChakraUiProvider";
import { useState, useEffect } from "react";
import axiosInstance from "./configs/axios.config";
import { useToast } from "@chakra-ui/react";
import TokenExpiredScreen from "./components/TokenExpiredScreen";

import RouteSegmentProvider from "./providers/RouteSegmentProvider";
import AuthValidationLayer from "./providers/AuthValidationLayer";

import { RootLayout } from "./components/RootLayout";

const App = () => {
  const toast = useToast();
  const [tokenExpired, setTokenExpired] = useState(false);

  useEffect(() => {
    // Listen for token expired event from axios interceptor
    const interceptor = axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        // Only a request sent with a session can mean "session expired". Requests made
        // while logged out (e.g. right after logout) carry no token and must not show it.
        const hadSession = !!error.config?.headers?.Authorization;
        if (error.response && error.response.status === 401 && hadSession) {
          setTokenExpired(true);
        }
        return Promise.reject(error);
      }
    );
    return () => {
      axiosInstance.interceptors.response.eject(interceptor);
    };
  }, []);

  //firebase notification setup
  useEffect(() => {
    const initFirebase = async () => {
      // The FCM token is saved against the logged-in admin; nothing to save when logged out
      if (!localStorage.getItem("prima_session")) return;

      const token = await requestNotificationPermission();

      console.log("FCM TOKEN:", token);

      // ✅ SAVE TOKEN TO BACKEND
      if (token) {
        try {

          await axiosInstance.post(
            "/api/notification/save-fcm-token",
            { token }
          );

          console.log("FCM token saved successfully");

        } catch (error) {
          console.log("Error saving FCM token:", error);
        }
      }
    };

    initFirebase();

    listenForMessages();

  }, []);

  // Remove toast, show full screen instead

  if (tokenExpired) {
    return (
      <ChakraUiProvider>
        <TokenExpiredScreen onSignin={() => setTokenExpired(false)} />
      </ChakraUiProvider>
    );
  }

  return (
    <ChakraUiProvider>
      <AuthValidationLayer>
        <RootLayout>
          <RouteSegmentProvider />
        </RootLayout>
      </AuthValidationLayer>
    </ChakraUiProvider>
  );
};

export default App;
